import * as yup from 'yup';
import _get from 'lodash/get';
import _keys from 'lodash/keys';
import { COUPON_TYPE } from 'commons/models/common';
import {
	Row,
	RenderConfig,
	Column,
	TextInput,
	SelectInput,
	NumberInput,
	EMPTY_ARRAY,
	EMPTY_OBJECT,
	CASE,
	BOOLEAN_OPTIONS
} from 'commons-ui';

import { TYPE_OPTIONS, ALLOWED_PAYMENT_MODES_OPTIONS } from './constants';

export const maxRedemptionPerPersonDependencyResolver = (props: any, dependencyValues: any) => {
	const allowUnlimitedRedemptionsPerPerson = _get(dependencyValues, '0', false);
	const isEditable = props.isEditable[props.mode];
	const { required, disabled } = props;

	if (allowUnlimitedRedemptionsPerPerson && isEditable && !disabled) {
		return { disabled: true };
	}

	if (allowUnlimitedRedemptionsPerPerson && required) {
		return { required: false };
	}

	if (!allowUnlimitedRedemptionsPerPerson && isEditable === disabled) {
		return { disabled: !isEditable };
	}

	if (!allowUnlimitedRedemptionsPerPerson && !required) {
		return { required: true };
	}

	return null;
};

export const maxRedemptionDependencyResolver = (props: any, dependencyValues: any) => {
	const allowUnlimitedRedemptions = _get(dependencyValues, '0', false);
	const isEditable = props.isEditable[props.mode];
	const { required, disabled } = props;

	if (allowUnlimitedRedemptions && isEditable && !disabled) {
		return { disabled: true };
	}

	if (allowUnlimitedRedemptions && required) {
		return { required: false };
	}

	if (!allowUnlimitedRedemptions && isEditable === disabled) {
		return { disabled: !isEditable };
	}

	if (!allowUnlimitedRedemptions && !required) {
		return { required: true };
	}

	return null;
};

export const isFirstDepositDependencyResolver = (props: any, dependencyValues: any) => {
	const type = _get(dependencyValues, '0', COUPON_TYPE.PARTNER_COUPON_CASHLESS);
	const isEditable = props.isEditable[props.mode];
	const { required, disabled } = props;

	if (type === COUPON_TYPE.PARTNER_COUPON_CASHLESS && isEditable && !disabled) {
		return { disabled: true };
	}

	if (type === COUPON_TYPE.PARTNER_COUPON_CASHLESS && required) {
		return { required: false };
	}

	if (type !== COUPON_TYPE.PARTNER_COUPON_CASHLESS && isEditable === disabled) {
		return { disabled: !isEditable };
	}

	if (type !== COUPON_TYPE.PARTNER_COUPON_CASHLESS && required) {
		return { required: true };
	}

	return null;
};

export const isSecondDepositDependencyResolver = (props: any, dependencyValues: any) => {
	const type = _get(dependencyValues, '0', COUPON_TYPE.PARTNER_COUPON_CASHLESS);
	const isEditable = props.isEditable[props.mode];
	const { required, disabled } = props;

	if (type === COUPON_TYPE.PARTNER_COUPON_CASHLESS && isEditable && !disabled) {
		return { disabled: true };
	}

	if (type === COUPON_TYPE.PARTNER_COUPON_CASHLESS && required) {
		return { required: false };
	}

	if (type !== COUPON_TYPE.PARTNER_COUPON_CASHLESS && isEditable === disabled) {
		return { disabled: !isEditable };
	}

	if (type !== COUPON_TYPE.PARTNER_COUPON_CASHLESS && required) {
		return { required: true };
	}

	return null;
};

export const allowedPaymentModesDependencyResolver = (props: any, dependencyValues: any) => {
	const type = _get(dependencyValues, '0', COUPON_TYPE.PARTNER_COUPON_CASHLESS);
	const isEditable = props.isEditable[props.mode];
	const { disabled } = props;

	if (type === COUPON_TYPE.PARTNER_COUPON_CASHLESS && isEditable && !disabled) {
		return { disabled: true };
	}

	if (type !== COUPON_TYPE.PARTNER_COUPON_CASHLESS && isEditable === disabled) {
		return { disabled: !isEditable };
	}

	return null;
};

export const amountDependencyResolver = (props: any, dependencyValues: any) => {
	const type = _get(dependencyValues, '0', COUPON_TYPE.PARTNER_COUPON_CASHLESS);
	const isEditable = props.isEditable[props.mode];
	const { required, disabled } = props;

	if (type === COUPON_TYPE.PARTNER_COUPON_CASHLESS && isEditable && !disabled) {
		return { disabled: true };
	}

	if (type === COUPON_TYPE.PARTNER_COUPON_CASHLESS && required) {
		return { required: false };
	}

	if (type !== COUPON_TYPE.PARTNER_COUPON_CASHLESS && isEditable === disabled) {
		return { disabled: !isEditable };
	}

	if (type !== COUPON_TYPE.PARTNER_COUPON_CASHLESS && required) {
		return { required: true };
	}

	return null;
};

export const conversionsDependencyResolver = (props: any, dependencyValues: any) => {
	const type = _get(dependencyValues, '0', COUPON_TYPE.PARTNER_COUPON_CASHLESS);

	const { maxLength, append, mode, arrayFields } = props;

	if (mode === 'edit') {
		return null;
	}

	if (type === COUPON_TYPE.PARTNER_COUPON_CASHLESS && maxLength > 1) {
		const newRow = { ...arrayFields[0], amount: 0 };
		delete newRow.id;
		append(newRow);
		return { maxLength: 1 };
	}

	if (type !== COUPON_TYPE.PARTNER_COUPON_CASHLESS && maxLength !== Number.MAX_SAFE_INTEGER) {
		return { maxLength: Number.MAX_SAFE_INTEGER };
	}

	return null;
};

export const validationSchemaCreate = yup.object().shape({
	code: yup
		.string()
		.matches(/^[A-Z]/, 'Code should start with alphabet')
		.matches(/^([A-Z0-9])+$/, 'Code should only contain alphanumeric characters')
		.required('Code is a required field'),
	description: yup.string().required('Description is a required field'),
	validFrom: yup
		.number()
		.transform((value, originalValue) => {
			if (originalValue === '' || originalValue === null) {
				return undefined;
			}
			return originalValue;
		})
		.test({
			message: 'Valid from should be valid date',
			test: (value: any) => value !== '' || value !== null || !Number.isNaN(new Date(value).getTime())
		})
		.test({
			message: 'Valid from should be greater than current time',
			test: (value: any) => new Date(value) > new Date()
		})
		.required('Valid from is a required field'),
	validTill: yup
		.number()
		.transform((value, originalValue) => {
			if (originalValue === '' || originalValue === null) {
				return undefined;
			}
			return originalValue;
		})
		.test({
			message: 'Valid till should be valid date',
			test: (value: any) => value !== '' || value !== null || !Number.isNaN(new Date(value).getTime())
		})
		.test({
			message: 'Valid till should be greater than current time',
			test: (value: any) => new Date(value) > new Date()
		})
		.required('Valid till is a required field'),
	isFirstDeposit: yup.boolean().required(),
	allowUnlimitedRedemptions: yup.boolean().nullable(),
	maxRedemptions: yup.number().when('allowUnlimitedRedemptions', {
		is: true,
		then: yup.number().nullable(),
		otherwise: yup.number().min(1, 'Maximum Redemptions should be atleast 1').required()
	}),
	conversions: yup
		.array()
		.of(
			yup.object().shape({
				amount: yup.number().required('Amount is a required field'),
				unlockedCoins: yup.number().required('Unlocked Coins is a required field'),
				actualCoins: yup.number().required('Actual Coins is a required field'),
				addedCoins: yup.number().required('Added Coins is a required field'),
				cashbackCoins: yup.number().required('Cashback Coins is a required field')
			})
		)
		.test({
			message: 'Atleast one conversion should be present',
			test: (arr: any) => arr.length >= 1
		})
		.required(),
	maxConversionPerRedemption: yup
		.object()
		.shape({
			unlockedCoins: yup.number().required('Unlocked Coins is a required field'),
			actualCoins: yup.number().required('Actual Coins is a required field'),
			addedCoins: yup.number().required('Added Coins is a required field'),
			cashbackCoins: yup.number().required('Cashback Coins is a required field')
		})
		.required(),

	isSecondDeposit: yup.boolean().required(),
	type: yup.string().oneOf(_keys(COUPON_TYPE)).required()
});

export const validationSchemaEdit = yup.object().shape({
	description: yup.string().required('Description is a required field'),
	validTill: yup
		.number()
		.transform((value, originalValue) => {
			if (originalValue === '' || originalValue === null) {
				return undefined;
			}
			return originalValue;
		})
		.test({
			message: 'Valid till should be valid date',
			test: (value: any) => value !== '' || value !== null || !Number.isNaN(new Date(value).getTime())
		})
		.test({
			message: 'Valid till should be greater than current time',
			test: (value: any) => new Date(value) > new Date()
		})
		.required('Valid till is a required field'),
	isFirstDeposit: yup.boolean().required(),
	allowUnlimitedRedemptions: yup.boolean().nullable(),
	maxRedemptions: yup.number().when('allowUnlimitedRedemptions', {
		is: true,
		then: yup.number().nullable(),
		otherwise: yup.number().min(1, 'Maximum Redemptions should be atleast 1').required('Maximum Redemptions is required field')
	}),
	allowUnlimitedRedemptionsPerPerson: yup
		.boolean()
		.when('isSecondDeposit', {
			is: true,
			then: yup.boolean().oneOf([false], 'Unlimited Redemptions per person can not be allowed if second deposit is true'),
			otherwise: yup.boolean().when('isFirstDeposit', {
				is: true,
				then: yup.boolean().oneOf([false], 'Unlimited Redemptions per person can not be allowed if first deposit is true')
			})
		})
		.nullable(),
	maxRedemptionsPerPerson: yup.number().when('isSecondDeposit', {
		is: true,
		then: yup.number().oneOf([1, 2], 'Maximum Redemptions Per Person should be 1 or 2 if second deposit is true').required(),
		otherwise: yup.number().when('isFirstDeposit', {
			is: true,
			then: yup.number().oneOf([1], 'Maximum Redemptions Per Person should be 1 if first deposit is true').required(),
			otherwise: yup.number().when('allowUnlimitedRedemptionsPerPerson', {
				is: true,
				then: yup.number().nullable(),
				otherwise: yup.number().min(1, 'Maximum Redemptions Per Person should be atleast 1').required()
			})
		})
	}),
	isSecondDeposit: yup.boolean().required(),
	type: yup.string().oneOf(_keys(COUPON_TYPE)).required()
});

export const FORM_FIELD_KEYS = {
	CODE: 'code',
	DESCRIPTION: 'description',
	TYPE: 'type',
	IS_DISABLED: 'isDisabled',
	IS_FIRST_DEPOSIT: 'isFirstDeposit',
	IS_SECOND_DEPOSIT: 'isSecondDeposit',
	ALLOW_UNLIMITED_REDEMPTIONS: 'allowUnlimitedRedemptions',
	MAX_REDEMPTIONS: 'maxRedemptions',

	// Commenting out redemption interval part as we might require it in the future

	// REDEMPTION_INTERVAL: 'redemptionInterval',

	VALID_FROM: 'validFrom',
	VALID_TILL: 'validTill',
	ALLOWED_PAYMENT_MODES: 'allowedPaymentModes',
	CONVERSIONS: 'conversions',
	AMOUNT: 'amount',
	TICKETS: 'tickets',
	UNLOCKED_COINS: 'unlockedCoins',
	BONUS_COINS: 'bonusCoins',
	ACTUAL_COINS: 'actualCoins',
	ADDED_COINS: 'addedCoins',
	CASHBACK_COINS: 'cashbackCoins',
	MAX_CONVERSION_PER_REDEMPTION: 'maxConversionPerRedemption',
	CASHBACK_REWARD_EXPIRY_IN_HOURS: 'cashbackExpiryInHours'
};

export const FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.CODE)]), new Column([new Row(FORM_FIELD_KEYS.TYPE)])]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.DESCRIPTION)])]),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.IS_FIRST_DEPOSIT)]),
		new Column([new Row(FORM_FIELD_KEYS.IS_SECOND_DEPOSIT)])
	]),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.ALLOW_UNLIMITED_REDEMPTIONS)]),
		new Column([new Row(FORM_FIELD_KEYS.MAX_REDEMPTIONS)])
	]),
	// new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.REDEMPTION_INTERVAL)])]),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.VALID_FROM)]),
		new Column([new Row(FORM_FIELD_KEYS.VALID_TILL)])
	]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.ALLOWED_PAYMENT_MODES)])]),
	new Row(FORM_FIELD_KEYS.CONVERSIONS, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.AMOUNT)]),
		new Column([new Row(FORM_FIELD_KEYS.UNLOCKED_COINS)]),
		new Column([new Row(FORM_FIELD_KEYS.ACTUAL_COINS)]),
		new Column([new Row(FORM_FIELD_KEYS.ADDED_COINS)]),
		new Column([new Row(FORM_FIELD_KEYS.CASHBACK_COINS)])
	]),
	new Row(FORM_FIELD_KEYS.MAX_CONVERSION_PER_REDEMPTION, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.UNLOCKED_COINS)]),
		new Column([new Row(FORM_FIELD_KEYS.ACTUAL_COINS)]),
		new Column([new Row(FORM_FIELD_KEYS.ADDED_COINS)]),
		new Column([new Row(FORM_FIELD_KEYS.CASHBACK_COINS)])
	]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.CASHBACK_REWARD_EXPIRY_IN_HOURS)])])
];

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.CODE]: new RenderConfig()
		.setName('code')
		.setLabel('Code')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: false }, letterCase: CASE.UPPERCASE, required: true })
		.setToolTip('Coupon Code'),
	[FORM_FIELD_KEYS.DESCRIPTION]: new RenderConfig()
		.setName('description')
		.setLabel('Description')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true }),
	[FORM_FIELD_KEYS.CASHBACK_REWARD_EXPIRY_IN_HOURS]: new RenderConfig()
		.setName('cashbackExpiryInHours')
		.setLabel('Cashback Expiry')
		.setRenderer(NumberInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: false })
		.setToolTip('Cashback Expiry In Hours'),
	[FORM_FIELD_KEYS.TYPE]: new RenderConfig()
		.setName('type')
		.setLabel('Type')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			options: TYPE_OPTIONS,
			required: true
		})
		.setToolTip('Type of coupons'),
	[FORM_FIELD_KEYS.IS_DISABLED]: new RenderConfig()
		.setName('isDisabled')
		.setLabel('Is Disabled')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: BOOLEAN_OPTIONS,
			required: true
		})
		.setToolTip('Is the coupon live on App'),
	[FORM_FIELD_KEYS.IS_FIRST_DEPOSIT]: new RenderConfig()
		.setName('isFirstDeposit')
		.setLabel('Is First Deposit')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: BOOLEAN_OPTIONS,
			dependencies: ['type'],
			dependencyResolver: isFirstDepositDependencyResolver
		})
		.setToolTip('Is valid only for first deposit. Disabled for cashless coupons'),
	[FORM_FIELD_KEYS.IS_SECOND_DEPOSIT]: new RenderConfig()
		.setName('isSecondDeposit')
		.setLabel('Is Second Deposit')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: BOOLEAN_OPTIONS,
			dependencies: ['type'],
			dependencyResolver: isSecondDepositDependencyResolver
		})
		.setToolTip('Is valid for first and second deposit. Disabled for cashless coupons'),
	[FORM_FIELD_KEYS.ALLOW_UNLIMITED_REDEMPTIONS]: new RenderConfig()
		.setName('allowUnlimitedRedemptions')
		.setLabel('Allow Unlimited Redemptions')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: BOOLEAN_OPTIONS
		})
		.setToolTip('Coupon can be used any number of times'),
	[FORM_FIELD_KEYS.MAX_REDEMPTIONS]: new RenderConfig()
		.setName('maxRedemptions')
		.setLabel('Maximum Redemptions')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			dependencies: ['allowUnlimitedRedemptions'],
			dependencyResolver: maxRedemptionDependencyResolver
		})
		.setToolTip('Maximum number of total redemptions allowed'),
	// [FORM_FIELD_KEYS.REDEMPTION_INTERVAL]: new RenderConfig()
	// 	.setName('redemptionInterval')
	// 	.setLabel('Redemption Interval')
	// 	.setRenderer(TimeIntervalInput)
	// 	.setRenderProps({
	// 		isEditable: { create: true, edit: true },
	// 		inputType: 'number'
	// 	})
	// 	.setToolTip('Applicable once in this time interval'),

	[FORM_FIELD_KEYS.VALID_FROM]: new RenderConfig()
		.setName('validFrom')
		.setLabel('Valid From')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			inputType: 'datetime-local',
			required: true
		}),
	[FORM_FIELD_KEYS.VALID_TILL]: new RenderConfig()
		.setName('validTill')
		.setLabel('Valid Till')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			inputType: 'datetime-local',
			required: true
		}),
	[FORM_FIELD_KEYS.ALLOWED_PAYMENT_MODES]: new RenderConfig()
		.setName('allowedPaymentModes')
		.setLabel('Allowed Payment Modes')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: ALLOWED_PAYMENT_MODES_OPTIONS,
			multi: true,
			dependencies: ['type'],
			dependencyResolver: allowedPaymentModesDependencyResolver
		})
		.setToolTip('Applicable on which payment modes. Disabled for cashless coupons'),
	[FORM_FIELD_KEYS.CONVERSIONS]: new RenderConfig()
		.setName('conversions')
		.setLabel('Payout Details')
		.setRenderProps({
			isArrayField: true,
			isEditable: { create: true, edit: false },
			maxLength: Number.MAX_SAFE_INTEGER,
			required: true,
			dependencies: ['type'],
			dependencyResolver: conversionsDependencyResolver
		}),
	[FORM_FIELD_KEYS.MAX_CONVERSION_PER_REDEMPTION]: new RenderConfig()
		.setName('maxConversionPerRedemption')
		.setLabel('Maximum Payout Per Redemption')
		.setToolTip('Maximum payout per redemption')
		.setRenderProps({ required: true }),
	[FORM_FIELD_KEYS.AMOUNT]: new RenderConfig()
		.setName('amount')
		.setLabel('Amount (in Paisa)')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			required: true,
			dependencies: ['type'],
			dependencyResolver: amountDependencyResolver
		}),
	[FORM_FIELD_KEYS.TICKETS]: new RenderConfig()
		.setName('tickets')
		.setLabel('Tickets')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			required: true
		}),
	[FORM_FIELD_KEYS.UNLOCKED_COINS]: new RenderConfig()
		.setName('unlockedCoins')
		.setLabel('Bonus Money (in Paisa)')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			required: true
		}),
	[FORM_FIELD_KEYS.BONUS_COINS]: new RenderConfig()
		.setName('bonusCoins')
		.setLabel('Bonus Coins')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			required: true
		}),
	[FORM_FIELD_KEYS.ACTUAL_COINS]: new RenderConfig()
		.setName('actualCoins')
		.setLabel('Winnings (in Paisa)')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			required: true
		}),
	[FORM_FIELD_KEYS.ADDED_COINS]: new RenderConfig()
		.setName('addedCoins')
		.setLabel('Play Money (in Paisa)')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			required: true
		}),
	[FORM_FIELD_KEYS.CASHBACK_COINS]: new RenderConfig()
		.setName('cashbackCoins')
		.setLabel('Cashback Money (in Paisa)')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			required: true
		})
};

export const getFormDefaults = () => {
	return {
		isDisabled: true,
		isFirstDeposit: false,
		isSecondDeposit: false,
		conversions: [{}],
		maxConversionPerRedemption: EMPTY_OBJECT,
		cashbackExpiryInHours: null,
		allowedPaymentModes: ['UPI'],
		validFrom: new Date().getTime(),
		validTill: new Date().getTime()
	};
};
